import { render, staticRenderFns } from "./ProduceControl.vue?vue&type=template&id=06c7f124&scoped=true&"
import script from "./ProduceControl.vue?vue&type=script&lang=js&"
export * from "./ProduceControl.vue?vue&type=script&lang=js&"
import style0 from "./ProduceControl.vue?vue&type=style&index=0&id=06c7f124&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c7f124",
  null
  
)

export default component.exports